"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.RECAPTCHA_SETTINGS = new core_1.InjectionToken('recaptcha-settings');



//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/node_modules/ng-recaptcha/recaptcha/recaptcha-settings.js
// module id = ../../../../ng-recaptcha/recaptcha/recaptcha-settings.js
// module chunks = vendor